export type ConstituentComplaintEvent = {
  id: number;
  constituent_complaint_id: number;
  user_id: number;
  actor_name: string;
  event_type: string;
  metadata: Record<string, unknown>;
  created_at: string;
};

export async function listConstituentComplaintEvents(
  municipalityId: number,
  complaintId: number,
): Promise<ConstituentComplaintEvent[]> {
  const response = await fetch(
    `/api/v1/municipalities/${municipalityId}/trust_complaints/${complaintId}/events`,
    { credentials: "include", headers: { Accept: "application/json" } },
  );
  if (!response.ok) throw new Error("Failed to load events");
  return response.json();
}
